import React from 'react'
import * as Yup from 'yup'

import { TokenListFields } from '../pathMapping/TokenListFields'

import {
  splitToken,
  joinToken,
  isQualifiedToken,
  isWholeValuePrefix,
  labelForPrefix,
  PATH_EXAMPLES,
  PREFIX_OPTION_GROUPS,
} from './tokenSources'

// The backend joins resolved values with " / " (CAMPAIGN_FIELD_SEPARATOR in
// intermedia_unite.py). Kept in sync so the preview matches what is actually sent.
const SEPARATOR = ' / '

const FIELD = 'voip_campaign_name_fields'

// A half-filled row serialises as "event:" -- harmless to the backend, which skips
// a token with an empty path, but invalid enough to gate the submit button.
export const CAMPAIGN_FIELDS_SCHEMA = Yup.array().of(
  Yup.string().test(
    'qualified-token',
    'Choose a source, and enter a path for Event Payload',
    isQualifiedToken
  )
)

const previewLabel = (token) => {
  const { prefix, path } = splitToken(token)
  if (!prefix) {
    return token
  }
  return path ? `${labelForPrefix(prefix)}:${path}` : labelForPrefix(prefix)
}

const intermediaUniteTokenCodec = {
  split: splitToken,
  join: joinToken,
  isQualified: isQualifiedToken,
}

/**
 * VOIP Campaign Name: an ordered list of sources joined with " / " in row order.
 *
 * Stores the backend shape directly -- an array of token strings -- so nothing
 * serialises it on submit. Injected via the schema `raw`/`as` hatch, so it reads
 * and writes Formik through context.
 *
 * No legacy seeding, unlike TCN: this connector has never shipped a customer with
 * a `voip_campaign_name` scalar set, and the backend still falls back to it when
 * the list is empty.
 */
export const IntermediaUniteCampaignNameFields = () => (
  <TokenListFields
    field={FIELD}
    label="VOIP Campaign Name"
    codec={intermediaUniteTokenCodec}
    sources={PREFIX_OPTION_GROUPS}
    examples={PATH_EXAMPLES}
    isWholeValue={isWholeValuePrefix}
    testIdPrefix="intermedia-unite-campaign"
    containerTestId="intermedia-unite-campaign-name"
    columnLabels={['Source', 'Path']}
    addLabel="Add source"
    removeLabel="Remove campaign name source"
    separator={SEPARATOR}
    previewLabel={previewLabel}
    caption={
      <>
        Sources are joined with &ldquo;{SEPARATOR}&rdquo; in row order. One that resolves to nothing
        is skipped; if none resolve, the campaign name is left unset. Leave the list empty for the
        default, Dialed Number then Hunt Group.
      </>
    }
  />
)
